import { SelectFormGroup } from "~/styles/FormGroup";

type SelectInputProps = {
    name: string;
    options: { label: string; value: string }[];
    onChange: (name: string, value: string) => void;
    onBlur?: (name: string, value: string) => void;
    error?: string;
    value?: string;
    label?: string;
    placeholder?: string;
    required?: boolean;
    Template?: any; // Styled-components theme
    small?: boolean;
    [key: string]: any;
};

const SelectInput = ({
    name,
    onChange,
    options,
    onBlur,
    required = false,
    small = false,
    error = "",
    placeholder = "",
    value = "",
    label = "",
    Template,
    ...props
}: SelectInputProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { value: dataValue } = e.target;
        onChange(name, dataValue);
    };

    const handleBlur = (e: React.ChangeEvent<HTMLSelectElement>) => {
        if (onBlur) {
            onBlur(name, e.target.value);
        }
    };

    const ContainerComponent = Template || SelectFormGroup;

    return (
        <>
            <ContainerComponent {...props} $small={small} $error={!!error} disabled={props.disabled}>
                {label ? (
                    <label htmlFor={name}>
                        <span>
                            {label}
                            {required ? " *" : ""}
                        </span>
                    </label>
                ) : (
                    ""
                )}

                <select
                    id={name}
                    name={name}
                    value={value}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={props.disabled}
                >
                    {placeholder ? <option value="">{placeholder}</option> : ""}
                    {options.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>

                {error && !value?.length ? (
                    <small className="error" style={{ color: "#a7258b" }}>
                        {error}
                    </small>
                ) : (
                    ""
                )}
            </ContainerComponent>
        </>
    );
};

export default SelectInput;
